{
  "addFleet": "Ajouter une flotte",
  "table": {
    "empty": "Aucune flotte n'a été trouvée",
    "column": {
      "fleet": "Flotte",
      "devices": "Équipements",
      "createdAt": "Date de création",
      "updatedAt": "Dernière modification",
      "incompatibleDevices": "Équipements incompatibles",
      "information": {
        "incompatibleDevices": "Certains équipements de la flotte ne sont pas compatibles avec les paramètres actuels.",
        "fleetHasChanged": "Le périmètre de la flotte a été modifié",
        "noDeviceCompatible": "Aucun équipement de la flotte n’est compatible avec les paramètres de la campagne"
      }
    }
  },
  "addDevices": "Ajouter des équipements",
  "form": {
    "createFleet": {
      "header": "Créer une nouvelle flotte",
      "validate": "Créer la flotte",
      "cancel": {
        "confirmMessage": "Êtes-vous sûr de vouloir annuler la création de la flotte ?"
      }
    },
    "validation": {
      "name": "Le nom est obligatoire",
      "uniqueName": "Le nom de la flotte doit être unique"
    },
    "header": {
      "addDevices": "Ajouter la sélection à une flotte",
      "createFleet": "Créer une flotte"
    },
    "newFleet": "Nouvelle flotte",
    "name": "Nom de la flotte",
    "saveSuccess": "La création de la flotte {fleetName} a été effectuée avec succès."
  },
  "attachDevices": {
    "updateSuccess": "Aucun équipement ajouté | L’ajout de l’équipement à la flotte {fleetName} a été effectué avec succès. | L’ajout des équipements à la flotte {fleetName} a été effectué avec succès.",
    "title": "Rattacher des équipements à la flotte",
    "confirmMessage": "Êtes-vous sûr de vouloir annuler l’opération ? Votre sélection sera perdue."
  },
  "removeDevices": {
    "confirmMessage": "Êtes-vous sûr de vouloir supprimer cet équipement de la flotte ? | Êtes-vous sûr de vouloir supprimer cet équipement de la flotte ? | Êtes-vous sûr de vouloir supprimer ces équipements de cette flotte ?",
    "confirmTitle": "Retirer de la flotte"
  },
  "actionForbidden": "Vous n’avez pas la permission d’effectuer cette action.",
  "delete": {
    "title": "Supprimer la flotte",
    "confirm": {
      "message": "Êtes-vous sûr de vouloir supprimer cette flotte ?"
    }
  },
  "quickActions": {
    "selectedFleets": "Aucune flotte sélectionnée | {count} flotte sélectionnée | {count} flottes sélectionnées",
    "delete": {
      "title": "Aucune flotte à supprimer | Supprimer une flotte | Supprimer des flottes"
    }
  },
  "bulkDelete": {
    "confirm": {
      "title": "Aucune flotte à supprimer | Supprimer la flotte | Supprimer les flottes",
      "message": "Aucune flotte à supprimer | Êtes-vous sûr de vouloir supprimer cette flotte ? | Êtes-vous sûr de vouloir supprimer ces flottes ?"
    }
  }
}
